<template>
  <section ref="preloaderRef" id="preloader">
    <div class="oz_wrapper">
      <img alt="OZ" class="oz" style="--i: 0" src="/images/icons/oz.svg"/>
      <img alt="OZ" class="oz" style="--i: 1" src="/images/icons/oz.svg"/>
      <img alt="OZ" class="oz" style="--i: 2" src="/images/icons/oz.svg"/>
      <br/>
      <img alt="OZ" class="oz" style="--i: 3" src="/images/icons/oz.svg"/>
      <img alt="OZ" class="oz" style="--i: 4" src="/images/icons/oz.svg"/>
      <img alt="OZ" class="oz" style="--i: 5" src="/images/icons/oz.svg"/>
      <img alt="OZ" class="oz" style="--i: 6" src="/images/icons/oz.svg"/>
      <br/>
      <img alt="OZ" class="oz" style="--i: 7" src="/images/icons/oz.svg"/>
      <img alt="OZ" class="oz" style="--i: 8" src="/images/icons/oz.svg"/>
      <img alt="OZ" class="oz" style="--i: 9" src="/images/icons/oz.svg"/>
      <img alt="OZ" class="oz" style="--i: 10" src="/images/icons/oz.svg"/>
      <img alt="OZ" class="oz" style="--i: 11" src="/images/icons/oz.svg"/>
      <br/>
      <img alt="OZ" class="oz" style="--i: 12" src="/images/icons/oz.svg"/>
      <img alt="OZ" class="oz" style="--i: 13" src="/images/icons/oz.svg"/>
      <img alt="OZ" class="oz" style="--i: 14" src="/images/icons/oz.svg"/>
      <img alt="OZ" class="oz" style="--i: 15" src="/images/icons/oz.svg"/>
      <br/>
      <img alt="OZ" class="oz" style="--i: 16" src="/images/icons/oz.svg"/>
      <img alt="OZ" class="oz" style="--i: 17" src="/images/icons/oz.svg"/>
      <img alt="OZ" class="oz" style="--i: 18" src="/images/icons/oz.svg"/>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger.js"

const preloaderRef = ref(null)
const emit = defineEmits(['complete'])

onMounted(() => {
  const root = preloaderRef.value
  if (!root) return

  const screenElement = document.getElementById('screen')

  if (screenElement) {
    gsap.set(screenElement, {
      scale: 0.7,
    })
  }

  const cleanup = () => {
    root.style.display = 'none'
    document.documentElement.style.overflow = ''
    document.body.style.overflow = ''
    if (screenElement) {
      screenElement.style.overflow = ''
      screenElement.style.transform = ''
    }
    ScrollTrigger.refresh()
    window.dispatchEvent(new CustomEvent('preloader-complete'))
    emit('complete')
  }

  const runExit = () => {
    // Exit анимация
    gsap.to(root, {
      scale: 0.5,
      opacity: 0,
      duration: 0.6,
      ease: 'power2.out',
      onComplete: cleanup
    })

    if (screenElement) {
      gsap.to(screenElement, {
        scale: 1,
        duration: 0.6,
        ease: 'power2.out',
        // Снимаем transform полностью, а не гасим его до единичного. Элемент с
        // transform становится опорой для position: fixed внутри себя, и превью
        // кейса, летящее за курсором, начинает считать координаты от прокрученного
        // #screen вместо окна — уезжает выше экрана.
        clearProps: 'transform'
      })
    }
  }

  // Не ждем window.load (картинки/шрифты/видео). Закрываем прелоадер, как только DOM готов,
  // либо сразу (если DOM уже не "loading"), но на следующий кадр для корректного первого paint.
  const scheduleExit = () => requestAnimationFrame(runExit)

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleExit, { once: true })
  } else {
    scheduleExit()
  }
})
</script>

<style scoped lang="scss">
@keyframes oz-pulse {
  0% {
    opacity: 0;
    transform: scale(0.8);
  }
  50% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(0.8);
  }
}

#preloader {
  position: fixed;
  z-index: 500;
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  height: 100%;
  cursor: default;
  user-select: none;
  overflow: hidden;
  background: rgb(var(--bg-canvas));
  align-items: center;
  justify-content: center;

  .oz_wrapper {
    text-align: center;

    .oz {
      display: inline-block;
      height: 0.875rem;
      margin: 0.4375rem;
      opacity: 0;
      transform: scale(0.8);
      animation: oz-pulse 3s cubic-bezier(0.16, 1, 0.3, 1) infinite;
      animation-delay: calc(var(--i) * 0.1s);
    }
  }
}
</style>
